import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environment';
import { AddSavedStopToRoutePayload, SavedStop, SavedStopPayload } from '../models/saved-stop.model';
import { normalizeApiArray } from '../utils/api-response.util';

@Injectable({ providedIn: 'root' })
export class SavedStopService {
  private readonly apiUrl = `${environment.apiUrl}/SavedStop`;

  constructor(private http: HttpClient) {}

  getSavedStops(filter: { organisationId?: number | null; search?: string; includeInactive?: boolean } = {}): Observable<SavedStop[]> {
    let params = new HttpParams();
    if (filter.organisationId) params = params.set('organisationId', String(filter.organisationId));
    if (filter.search?.trim()) params = params.set('search', filter.search.trim());
    if (filter.includeInactive) params = params.set('includeInactive', 'true');
    return this.http.get<unknown>(this.apiUrl, { params }).pipe(
      map(response => normalizeApiArray<SavedStop>(response))
    );
  }

  createSavedStop(payload: SavedStopPayload): Observable<SavedStop> {
    return this.http.post<SavedStop>(this.apiUrl, payload);
  }

  updateSavedStop(id: number, payload: SavedStopPayload): Observable<SavedStop> {
    return this.http.put<SavedStop>(`${this.apiUrl}/${id}`, payload);
  }

  deactivateSavedStop(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  addToRoute(id: number, payload: AddSavedStopToRoutePayload): Observable<unknown> {
    return this.http.post(`${this.apiUrl}/${id}/route-stops`, payload);
  }
}
